<div class="login-container">
  <!-- Left Side - Image -->
  <app-left-ui [welcomeText]="'Join Our Platform'" [welcomeSubtitle]="'Start your journey with us today and unlock amazing features'"></app-left-ui>

  <!-- Right Side - Form -->
  <div class="login-form">
    <a [routerLink]="['/']" class="btn home-btn">
      <i class="fa-solid fa-arrow-left"></i> Home
    </a>
    <div class="form-container">
      <div class="form-header">
        <h2 class="form-title">Sign Up</h2>
        <p class="form-subtitle">
          Fill in your details to create an account
        </p>
      </div>

      <form
        #registerForm="ngForm"
        (ngSubmit)="onSubmitForm()"
        autocomplete="off"
        class="registration-form">
        


        <div class="form-row" style="display: flex; gap: 15px;">
          <div class="form-group" style="flex: 1;">
            <label for="email"><i class="fa-solid fa-envelope me-2"></i>Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              class="form-control"
              [(ngModel)]="model.email"
              required
              email
              #email="ngModel"
              placeholder="Enter your email" />
            <div
              *ngIf="email.invalid && (email.dirty || email.touched)"
              class="error-message">
              <small *ngIf="email.errors?.['required']">Email is required.</small>
              <small *ngIf="email.errors?.['email']">Please enter a valid email address.</small>
            </div>
          </div>
        </div>



        <div class="form-group mb-2">
          <label for="password" class="mb-2">Password</label>
          <div class="password-wrap with-left-icon">
            <i class="fa-solid fa-lock input-icon-left"></i>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              name="password"
              class="form-control"
              [(ngModel)]="model.password"
              required
              #password="ngModel"
              placeholder="Create a secure password" />
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
              <i class="fa-solid" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>

        </div>

        <div class="form-group mb-2 mt-4">
          <label for="confirmPassword" class="mb-2">Confirm password</label>
          <div class="password-wrap with-left-icon">
            <i class="fa-solid fa-lock input-icon-left"></i>
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              name="confirmPassword"
              class="form-control"
              [(ngModel)]="model.confirmPassword"
              required
              #confirmPassword="ngModel"
              placeholder="Confirm your password" />
            <button type="button" class="toggle-password" (click)="toggleConfirmPasswordVisibility()">
              <i class="fa-solid" [ngClass]="showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>
          
          <!-- Password Requirements -->
          <div class="meter mt-2"><div class="meter-fill" [style.width.%]="passwordStrength * 25" [ngStyle]="{'background-color': getStrengthColor()}"></div></div>
          <div class="pw-hint" [innerHTML]="getStrengthLabel()"></div>

          <div *ngIf="model.confirmPassword && !passwordsMatch" class="error-message mt-1">
            <small class="text-danger"><i class="fa-solid fa-circle-exclamation me-1"></i>Passwords do not match</small>
          </div>
        </div>

        <div class="form-options mt-3 mb-4" style="display: flex; flex-direction: column; gap: 10px; align-items: flex-start;">
          <div class="remember-me">
            <input
              type="checkbox"
              id="tos"
              name="tos"
              [(ngModel)]="model.tos"
              required />
            <label for="tos" style="color: #333;">I agree to the <a routerLink="/terms-of-services" target="_blank" style="color: #c93b8c; text-decoration: underline;">Terms of Service</a></label>
          </div>
          <div class="remember-me">
            <input
              type="checkbox"
              id="privacy"
              name="privacy"
              [(ngModel)]="model.privacy"
              required />
            <label for="privacy" style="color: #333;">I agree to the <a routerLink="/privacy-policy" target="_blank" style="color: #c93b8c; text-decoration: underline;">Privacy Policy</a></label>
          </div>
          <div class="remember-me">
            <input
              type="checkbox"
              id="newsletter"
              name="newsletter"
              [(ngModel)]="model.newsletter" />
            <label for="newsletter" style="color: #333;">Subscribe to newsletter</label>
          </div>
        </div>

        <button
          type="submit"
          class="login-btn"
          [disabled]="isLoading">
          <span *ngIf="!isLoading"> Create Account </span>
          <span *ngIf="isLoading">
            <i class="fa-solid fa-circle-notch fa-spin me-2"></i>Creating...
          </span>
        </button>
      </form>

      <div class="divider">
        <span>Already have an account?</span>
      </div>
      <div class="signup-link">
        <a routerLink="/auth/login" class="register-link">
          Sign in
        </a>
      </div>
    </div>
  </div>
</div>
